module.exports = __webpack_public_path__ + "img/invoice_slider.5fbef5ba.jpg";